/**
 * A document saved as HTML only (written before block snapshots, or by an
 * MCP / AI write, which clears `bodyLexical`) → blocks, through the editor's
 * own HTML import — the same thing the editor does when it opens it.
 */
import { $getRoot, $createParagraphNode } from 'lexical';
import { $generateNodesFromDOM } from '@lexical/html';
import { createDocEditor } from './docEditor';
import { sanitizeRichTextHtml } from '../sanitizeHtml';

export function htmlToBlocks(bodyHtml) {
  const dom = new DOMParser().parseFromString(sanitizeRichTextHtml(bodyHtml || ''), 'text/html');
  const editor = createDocEditor();
  editor.update(
    () => {
      const root = $getRoot();
      root.clear();
      // Inline nodes the import leaves at the top level go into a paragraph, as in the editor.
      let para = null;
      for (const node of $generateNodesFromDOM(editor, dom)) {
        if (node.isInline && node.isInline()) {
          if (!para) {
            para = $createParagraphNode();
            root.append(para);
          }
          para.append(node);
        } else {
          para = null;
          root.append(node);
        }
      }
    },
    { discrete: true }
  );
  return editor.getEditorState().toJSON().root.children;
}
